import { ToggleRenderProps } from './props';
import styles from './styles.module.scss';

/**
 * ToggleRender Component
 * A responsive component that conditionally renders different content for desktop and mobile views.
 * Uses CSS classes to handle the display logic based on viewport size.
 *
 * @component
 * @param {Object} props - Component props
 * @param {ReactNode} props.desktopComponent - Component to render in desktop view
 * @param {ReactNode} props.mobileComponent - Component to render in mobile view
 * @returns {JSX.Element} The rendered toggle component with desktop and mobile variants
 *
 * @example
 * <ToggleRender
 *   desktopComponent={<div>Desktop Version</div>}
 *   mobileComponent={<div>Mobile Version</div>}
 * />
 */
export function ToggleRender({
  desktopComponent,
  mobileComponent,
}: ToggleRenderProps) {
  return (
    <div className={styles.container}>
      <div className={styles.container__desktop__only}>{desktopComponent}</div>
      <div className={styles.container__mobile__only}>{mobileComponent}</div>
    </div>
  );
}
